import { Link } from "react-router-dom";
import { Instagram, Twitter, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 bg-[#050507] mt-32 pb-24 md:pb-12" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-6 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 rounded-full silver-gradient flex items-center justify-center text-[#050507] font-black font-display">555</div>
            <div>
              <div className="font-display text-lg">555 Auto Brokers</div>
              <div className="label-mono mt-1">LUXURY CONCIERGE</div>
            </div>
          </div>
          <p className="text-sm text-gray-400 leading-relaxed max-w-md">
            Nationwide auto broker and AI-powered concierge. Luxury vehicle sourcing, lease deal marketplace, and financing concierge — built for buyers who value time.
          </p>
          <div className="flex gap-3 mt-6">
            <a href="https://instagram.com" aria-label="Instagram" className="w-9 h-9 rounded-full glass flex items-center justify-center hover:bg-white/10 transition" data-testid="footer-instagram"><Instagram className="w-4 h-4" /></a>
            <a href="https://twitter.com" aria-label="Twitter" className="w-9 h-9 rounded-full glass flex items-center justify-center hover:bg-white/10 transition" data-testid="footer-twitter"><Twitter className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <div className="label-mono mb-4">Marketplace</div>
          <ul className="space-y-3 text-sm text-gray-400">
            <li><Link to="/lease-deals" className="hover:text-white">Lease Deals</Link></li>
            <li><Link to="/find-my-car" className="hover:text-white">Find A Car</Link></li>
            <li><Link to="/financing" className="hover:text-white">Financing</Link></li>
            <li><Link to="/trade-in" className="hover:text-white">Trade-In</Link></li>
            <li><Link to="/exotic" className="hover:text-white">Exotic Quote</Link></li>
          </ul>
        </div>

        <div>
          <div className="label-mono mb-4">Popular</div>
          <ul className="space-y-3 text-sm text-gray-400">
            <li><Link to="/best-bmw-lease-deals" className="hover:text-white">Best BMW</Link></li>
            <li><Link to="/best-mercedes-lease-deals" className="hover:text-white">Best Mercedes</Link></li>
            <li><Link to="/best-luxury-suv-lease-deals" className="hover:text-white">Luxury SUVs</Link></li>
            <li><Link to="/best-ev-lease-deals" className="hover:text-white">Best EVs</Link></li>
            <li><Link to="/best-cars-under-500-month" className="hover:text-white">Under $500/mo</Link></li>
          </ul>
        </div>

        <div>
          <div className="label-mono mb-4">Company</div>
          <ul className="space-y-3 text-sm text-gray-400">
            <li><Link to="/how-it-works" className="hover:text-white">How It Works</Link></li>
            <li><Link to="/blog" className="hover:text-white">Journal</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/booking" className="hover:text-white">Book a Call</Link></li>
            <li><Link to="/dealer-portal" className="hover:text-white">Dealer Partners</Link></li>
          </ul>
        </div>

        <div>
          <div className="label-mono mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-gray-400">
            <li className="flex items-center gap-2"><Phone className="w-3.5 h-3.5" /> 1-555-AUTO-BRK</li>
            <li className="flex items-center gap-2"><Mail className="w-3.5 h-3.5" /> hello@555auto.com</li>
            <li className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5" /> Charlotte, NC</li>
          </ul>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="text-[11px] text-gray-500 max-w-3xl">
          Lease offers are subject to credit approval, location, tax, title, registration, dealer fees, and availability. Final payment may vary. 555 Auto Brokers is a licensed auto broker, not a dealership.
        </p>
        <p className="text-[11px] text-gray-500">© 2026 555 Auto Brokers</p>
      </div>
    </footer>
  );
}
